<template>
	<div
		class="g-block-audio-header"
		:class="{
			'g-block-audio-header--edit': editable,
			'is-active': editable && active,
			'g-block-audio-header--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-audio-header__player-box">
		<HeaderAudioPreview
			v-if="audioItem"
			:item="audioItem"
			layout="inline"
			:h5="h5"
			:id-key="idKey"
		/>
		</div>
	</div>
</template>

<script>
	import HeaderAudioPreview from '../../../components/HeaderAudioPreview.vue';
	import { getHeaderAudioItem } from '../../../utils/localAudio.js';
	import { normalizeAudioHeaderData } from '../../../utils/audioHeader.js';

	export default {
		name: 'GBlockAudioHeader',
		components: { HeaderAudioPreview },
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
			idKey: {
				type: String,
				default: '',
			},
		},
		emits: ['select'],
		computed: {
			audioData() {
				return normalizeAudioHeaderData(this.data);
			},
			audioItem() {
				return getHeaderAudioItem(this.audioData);
			},
		},
		methods: {
			onWrapClick() {
				if (this.editable) {
					this.$emit('select');
				}
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-audio-header {
		box-sizing: border-box;

		&__player-box {
			border: 1px solid #eee;
			border-radius: 4px;
			background: #fff;
			overflow: hidden;
		}

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}
</style>
